import RefluencedLogo from "@/assets/images/refluenced.svg";
import DownloadAppButton from "@/components/Common/DownloadAppButton";
import TextButton from "@/components/Common/TextButton";
import {useLogout} from "@/hooks/useLogout";
import {FC} from "react";
import {useTranslation} from "react-i18next";

const InfluencerAppRedirectCta: FC = () => {
  const {t} = useTranslation("common");
  const logout = useLogout();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
      <img src={RefluencedLogo} className="size-16" alt="Refluenced" />
      <div className="flex max-w-md flex-col gap-2">
        <h1 className="text-neutral-black text-2xl font-bold">{t("influencer_web_only_title")}</h1>
        <p className="text-neutral-grey-dark text-base">{t("influencer_web_only_description")}</p>
      </div>
      <DownloadAppButton />
      <TextButton text={t("clickToLogout")} onClick={logout} className="text-sm" />
    </div>
  );
};

export default InfluencerAppRedirectCta;
